<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" fill="#D58C51" />
    <g clip-path="url(#clip0_1_277)">
      <path
        d="M34.0746 23.2041H30.1774L27.379 15.239C27.2096 14.7568 26.6815 14.5032 26.1992 14.6726C25.717 14.842 25.4635 15.3702 25.6329 15.8524L28.2157 23.2041H20.7843L23.3671 15.8524C23.5365 15.3702 23.283 14.842 22.8008 14.6726C22.3187 14.5032 21.7904 14.7568 21.621 15.239L18.8226 23.2041H14.9254C14.4143 23.2041 14 23.6184 14 24.1295C14 24.6406 14.4143 25.0549 14.9254 25.0549H15.1789L17.4465 33.3309C17.6163 33.9505 18.1793 34.38 18.8217 34.38H30.2413C30.8871 34.38 31.4522 33.946 31.6189 33.3221L33.8274 25.0549H34.0746C34.5857 25.0549 35 24.6406 35 24.1295C35 23.6185 34.5857 23.2041 34.0746 23.2041ZM21.4678 31.3549C21.4678 31.866 21.0535 32.2803 20.5425 32.2803C20.0314 32.2803 19.6171 31.866 19.6171 31.3549V26.6562C19.6171 26.1451 20.0314 25.7308 20.5425 25.7308C21.0535 25.7308 21.4678 26.1451 21.4678 26.6562V31.3549ZM25.4254 31.3549C25.4254 31.866 25.011 32.2803 24.5 32.2803C23.9889 32.2803 23.5746 31.866 23.5746 31.3549V26.6562C23.5746 26.1451 23.9889 25.7308 24.5 25.7308C25.011 25.7308 25.4254 26.1451 25.4254 26.6562V31.3549ZM29.3829 31.3549C29.3829 31.866 28.9686 32.2803 28.4575 32.2803C27.9464 32.2803 27.5321 31.866 27.5321 31.3549V26.6562C27.5321 26.1451 27.9464 25.7308 28.4575 25.7308C28.9686 25.7308 29.3829 26.1451 29.3829 26.6562V31.3549Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_277">
        <rect
          width="21"
          height="21"
          fill="white"
          transform="translate(14 14)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconCart",
};
</script>

<style scoped>
circle,
path {
  transition: all ease 0.3s;
}
</style>
